<yc-modal *ngIf="!!formGroup"
  [ycHidden]="hideModal"
  [formGroup]="formGroup"
  [modalHeader]="'common:hdrUpdateUsers' | ycI18n: 'Update Users'"
  [primaryButtonText]="'common:btnSave' | ycI18n: 'Save'"
  [primaryDisabled]="formGroup.invalid || selectedAudiences.length === 0"
  [secondaryButtonText]="'common:textCreateAudience' | ycI18n: 'Create audience'"
  [cancelButtonText]="'common:btnCancel' | ycI18n: 'Cancel'"
  (onCancel)="closeModal.emit()"
  (onSecondaryClick)="createAudience()"
  (onPrimaryClick)="onPrimaryClick()">

  <div class="mb-3">
    <yc-tags #tags
      [label]="'WORKFLOW:hdrSelectedWorkflowLevels' | ycI18n: 'Selected Workflow Levels'"
      [placeholder]="''"
      [secondaryPlaceholder]="''"
      [autocompleteItems]="workflowLevelOptions"
      [name]="'workflowLevelIds'">
    </yc-tags>
  </div>

  <div class="mb-3">
    <yc-typeahead-select
      name="permission"
      [items]="permissionOptions"
      [help]="'common:textPermissionToBeAppliedToMembers' | ycI18n: 'Permission to be applied to audience members'"
      [label]="'common:textPermission' | ycI18n: 'Permission'">
    </yc-typeahead-select>
  </div>

  <gc-audiences-page
    [isModalView]="true"
    (onSelectedAudiencesChange)="selectedAudiences = $event"
    (onModalToggle)="hideModal = $event">
  </gc-audiences-page>

</yc-modal>